// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Minimal helper styling for OTC RFQ Page - follows Spot Trade theme */

.badge-soft-success {
    background-color: rgba(14, 203, 129, 0.15) !important;
    color: #0ecb81 !important;
    border-radius: 12px;
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 600;
    display: inline-block;
}

.badge-soft-danger {
    background-color: rgba(246, 70, 93, 0.15) !important;
    color: #f6465d !important;
    border-radius: 12px;
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 600;
    display: inline-block;
}

.trade_card.trade_chart.buysell_card.buysell_two .small {
    opacity: 1;
}

.otc_tradingpage .col-12.mmn_btm_minus_spc {
    width: 21%;
    padding-left: 1px;
}

.otc_tradingpage .midgraph_col {
    width: 79%;
}

.otc_tradingpage .trade_card.p-2.overflow_card.mb-1 {
    width: 100%;
    height: 57px;
}

.trade_card.p-3.marketsnapshot {
    width: 25.8%;
}

.gradebtn {
    color: #D1AA67;
    background: rgb(240 240 240 / 7%);
    font-weight: 600;
    border-radius: 16px;
    font-size: 11px;
    gap: 5px;
}

body.light_theme .gradebtn {
    background: #F0F0F0;
}

.otc_tradingpage .mmn_btm_minus_spc h5.mb-0 {
    font-size: 16px;
    font-weight: 700;
}

.otc_tradingpage .buysell_heder {
    padding: 3px 0px 8px 0px !important;
}

.otc-pair-menu {
    position: relative;
    margin-bottom: 12px;
}

.otc-pair-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.04);
    color: #fff;
    border-radius: 8px;
    padding: 8px 10px;
    text-align: left;
    cursor: pointer;
}

body.light_theme .otc-pair-trigger {
    color: #111;
    background: #f7f7f7;
    border-color: #e5e7eb;
}

.otc-pair-menu {
    z-index: 30;
}

.otc_tradingpage .trade_card.buysell_card.buysell_two,
.otc_tradingpage .buysellform {
    overflow: visible;
}

.otc-pair-menu .otc-graph-pairs {
    display: block;
    position: absolute;
    z-index: 40;
    left: 0;
    right: 0;
    top: calc(100% + 4px);
    height: auto;
    max-height: 420px;
    overflow: auto;
    background: #1e2329;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
    padding: 8px 8px 4px;
}

.otc-pair-search {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 12px;
}

.otc-pair-search i {
    color: #848e9c;
}

.otc-pair-search input {
    flex: 1 1;
    border: 0;
    outline: 0;
    background: transparent;
    color: inherit;
    font-size: 13px;
}

.otc-header-pair {
    position: relative;
}

.otc-header-pair__btn {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 0;
    background: transparent;
    color: inherit;
    padding: 0;
    cursor: pointer;
    text-align: left;
}

.otc-header-pair__text {
    display: flex;
    flex-direction: column;
    line-height: 1.15;
}

.otc-header-pair__symbol {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
}

.otc-header-pair__name {
    font-size: 11px;
    color: #848e9c;
}

.trade_card.buysell_card.buysell_two .spotLists {
    box-shadow: none;
}

.otc_tradingpage .otc-pair-drawer-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    z-index: 999998;
    animation: otcDrawerBackdropFadeIn 0.35s ease forwards;
}

@keyframes otcDrawerBackdropFadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.otc_tradingpage .otc-header-pair .trade_pairs_drawer_header {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 0 0 16px 0 !important;
    margin-bottom: 12px !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.otc_tradingpage .otc-header-pair .trade_pairs_drawer_title {
    font-size: 16px !important;
    font-weight: 700 !important;
    color: #eaecef !important;
    letter-spacing: -0.2px !important;
}

.otc_tradingpage .otc-header-pair .trade_pairs_drawer_close {
    border: 0 !important;
    background: rgba(255, 255, 255, 0.08) !important;
    color: #848e9c !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 8px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 20px !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
}

.otc_tradingpage .otc-header-pair .trade_pairs_drawer_close:hover {
    background: rgba(255, 255, 255, 0.16) !important;
    color: #ffffff !important;
    transform: scale(1.05) !important;
}

.trade-wrapper .letsidebar_tradetbl .orderbook-table th {
    background-color: #212227 !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: auto !important;
    margin: 0 !important;
    width: min(440px, 94vw) !important;
    height: 100vh !important;
    max-height: 100vh !important;
    background-color: #212328f0 !important;
    box-shadow: -10px 0 36px rgba(0, 0, 0, 0.55) !important;
    z-index: 99999999 !important;
    display: flex !important;
    border-radius: 0px;
    flex-direction: column !important;
    padding: 20px 8px !important;
    border-left: 1px solid rgba(255, 255, 255, 0.08) !important;
    transform: translateX(100%) !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
    transition: transform 0.45s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.35s ease, visibility 0.45s !important;
    overflow: hidden !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft.is-open {
    transform: translateX(0) !important;
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: auto !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft.is-collapsed {
    display: flex !important;
    transform: translateX(100%) !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .spotLists {
    display: flex !important;
    flex-direction: column !important;
    position: relative !important;
    width: 100% !important;
    max-width: none !important;
    height: 100% !important;
    max-height: 100% !important;
    min-height: 0 !important;
    overflow: hidden !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search {
    flex: 0 0 auto !important;
    margin-bottom: 12px !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search .ivu-input {
    background: #2b313c !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    border-radius: 8px !important;
    padding: 8px 12px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    height: 40px !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search .ivu-input input {
    background: transparent !important;
    border: none !important;
    color: #eaecef !important;
    font-size: 13px !important;
    width: 100% !important;
    outline: none !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .favorites_list_tabs {
    flex: 0 0 auto !important;
    display: flex !important;
    gap: 6px !important;
    padding: 0 0 10px 0 !important;
    margin: 0 !important;
    list-style: none !important;
    overflow-x: auto !important;
    scrollbar-width: none !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .favorites_list_tabs::-webkit-scrollbar {
    display: none !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card,
.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card.table-responsive {
    flex: 1 1 auto !important;
    height: 100% !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    padding-right: 2px !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card::-webkit-scrollbar {
    width: 4px;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 4px;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr {
    cursor: pointer !important;
    transition: background 0.18s ease;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr:hover {
    background: rgba(255, 255, 255, 0.05) !important;
}

.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr.active {
    background: rgba(240, 185, 11, 0.12) !important;
}

body.light_theme .otc_tradingpage .otc-pair-drawer-backdrop {
    background: rgb(255 255 255 / 35%);
}

body.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft {
    background-color: #ffffff !important;
    border-left: 1px solid #e6e8ea !important;
    box-shadow: -10px 0 36px rgba(0, 0, 0, 0.15) !important;
}

body.light_theme .otc_tradingpage .otc-header-pair .trade_pairs_drawer_header {
    border-bottom: 1px solid #edf0f3 !important;
}

body.light_theme .otc_tradingpage .otc-header-pair .trade_pairs_drawer_title {
    color: #1e2329 !important;
}

body.light_theme .otc_tradingpage .otc-header-pair .trade_pairs_drawer_close {
    background: #f4f5f7 !important;
    color: #707a8a !important;
}

body.light_theme .otc_tradingpage .otc-header-pair .trade_pairs_drawer_close:hover {
    background: #e9eaec !important;
    color: #1e2329 !important;
}

body.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search .ivu-input {
    background: #f5f6f8 !important;
    border: 1px solid #e6e8ea !important;
}

body.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search .ivu-input input {
    color: #1e2329 !important;
}

body.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr:hover {
    background: #f7f8fa !important;
}

body.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr.active {
    background: rgba(240, 185, 11, 0.12) !important;
}

.otc-pair-recent__head,
.otc-pair-tabs {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    color: #848e9c;
    font-size: 12px;
}

.otc-pair-recent__head {
    justify-content: space-between;
}

.otc-pair-recent__head button,
.otc-pair-tabs button {
    border: 0;
    background: transparent;
    color: #848e9c;
    padding: 0;
    cursor: pointer;
}

.otc-pair-tabs button.is-active {
    color: #fff;
    box-shadow: inset 0 -2px 0 #f0b90b;
}

.otc-pair-recent__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
}

.otc-pair-recent__chips button {
    border: 0;
    background: rgba(255, 255, 255, 0.06);
    color: #eaecef;
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 12px;
    cursor: pointer;
}

.otc-pair-result {
    display: grid;
    grid-template-columns: 16px 18px 1fr auto auto;
    align-items: center;
    gap: 8px;
    width: 100%;
    border: 0;
    background: transparent;
    color: #eaecef;
    border-radius: 6px;
    padding: 7px 4px;
    text-align: left;
    cursor: pointer;
}

.otc-pair-result:hover,
.otc-pair-result.is-active {
    background: rgba(255, 255, 255, 0.04);
}

.otc-pair-result .ri-star-fill {
    color: #f0b90b;
}

.otc-pair-result__rank,
.otc-pair-result__symbol {
    font-size: 13px;
    font-weight: 600;
}

.otc-pair-result__price,
.otc-pair-result__change {
    font-size: 12px;
    font-variant-numeric: tabular-nums;
}

.otc-pair-result__change.is-up {
    color: #0ecb81;
}

.otc-pair-result__change.is-down {
    color: #f6465d;
}

body.light_theme .otc-pair-tabs button.is-active,
body.light_theme .otc-pair-result {
    color: #111;
}

.otc-pair-menu .otc-graph-pairs .spot-list-search {
    margin-bottom: 8px;
}

.otc-pair-menu .otc-graph-pairs .favorites_list_tabs {
    margin: 0 0 8px;
}

.otc-pair-menu .otc-graph-pairs .price_card,
.otc-pair-menu .otc-graph-pairs .table-responsive {
    height: auto;
    min-height: 0;
    max-height: none;
    overflow: visible;
}

body.light_theme .otc-pair-menu .otc-graph-pairs {
    background: #fff;
    border-color: #e5e7eb;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}

.otc-active-pairs-list {
    position: absolute;
    z-index: 30;
    left: 0;
    right: 0;
    top: calc(100% + 4px);
    background: #1e2329;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
    padding: 4px;
}

.otc-active-pairs-empty {
    font-size: 12px;
    color: #848e9c;
    padding: 8px 0;
}

.otc-active-pairs-list {
    max-height: 220px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

body.light_theme .otc-active-pairs-list {
    background: #fff;
    border-color: #e5e7eb;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}

.otc-active-pair {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    border: 0;
    background: transparent;
    color: #fff;
    border-radius: 8px;
    padding: 6px 8px;
    text-align: left;
    cursor: pointer;
}

.otc-active-pair:hover,
.otc-active-pair.is-active {
    background: rgba(209, 170, 103, 0.16);
}

.otc-active-pair-symbol {
    flex: 1 1;
    font-size: 13px;
    font-weight: 600;
}

.otc-active-pair-price {
    font-size: 12px;
    font-variant-numeric: tabular-nums;
}

.otc-active-pair-price.is-up {
    color: #0ecb81;
}

.otc-active-pair-price.is-down {
    color: #f6465d;
}

body.light_theme .otc-active-pair {
    color: #111;
}

.otc_tradingpage a.requestquotebtn {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
}

.otc_tradingpage .requestquotebtn,
.otc_tradingpage .requestquotebtn:hover,
.otc_tradingpage .requestquotebtn:focus,
.otc_tradingpage .requestquotebtn:active,
.otc_tradingpage .requestquotebtn:disabled {
    background-color: #D1AA67 !important;
    border: none !important;
    font-size: 13px;
    min-height: 40px;
    font-weight: 500;
    border-radius: 50px;
    color: #fff !important;
    box-shadow: none !important;
    opacity: 1;
}

.otc_tradingpage .requestquotebtn:hover,
.otc_tradingpage .requestquotebtn:focus,
.otc_tradingpage .requestquotebtn:active {
    background-color: #c49b58 !important;
}

.otc_tradingpage .requestquotebtn:disabled {
    opacity: 0.7;
}

.otc_tradingpage h6.font-weight-bold.mb-0 {
    font-size: 14px;
    font-weight: 600;
}

.listotctrade span.font-weight-bold {
    color: #fff;
    opacity: 1;
    font-weight: 600;
}

body.light_theme .listotctrade span.font-weight-bold {
    color: #000;

}

.quotedeskawaiting {
    width: 100%;
    background-color: rgb(237 237 237 / 10%);
    padding: 12px;
    border-radius: 12px;
    margin: 16px 0px;
}

body.light_theme .quotedeskawaiting {
    background-color: #EDEDED;
}

.otc-accept-overlay {
    position: fixed;
    inset: 0;
    z-index: 100000000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(8, 10, 16, 0.72);
    -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
}

.otc-accept-modal {
    width: min(440px, 100%);
    max-height: min(92vh, 760px);
    overflow: auto;
    background: #1b1d24;
    color: #fff;
    border: 1px solid rgba(209, 170, 103, 0.35);
    border-radius: 16px;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
    padding: 20px 20px 16px;
}

body.light_theme .otc-accept-modal {
    background: #fff;
    color: #111;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
}

.otc-accept-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.otc-accept-kicker {
    margin: 0 0 2px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #d1aa67;
}

.otc-accept-head h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
}

.otc-accept-close {
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.08);
    color: #c5c8ce;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
}

body.light_theme .otc-accept-close {
    background: #f0f0f0;
    color: #444;
}

.otc-accept-lead {
    margin: 12px 0 0;
    font-size: 13px;
    line-height: 1.45;
    color: #c5c8ce;
}

body.light_theme .otc-accept-lead,
body.light_theme .otc-accept-note {
    color: #4b5563;
}

.otc-accept-timer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-top: 14px;
    padding: 10px 12px;
    border-radius: 10px;
    background: rgba(209, 170, 103, 0.16);
    color: #f0c079;
    font-size: 13px;
    font-weight: 700;
}

.otc-accept-timer span {
    font-weight: 600;
    font-size: 12px;
}

.otc-accept-timer.is-expired {
    background: rgba(246, 70, 93, 0.16);
    color: #f6465d;
}

body.light_theme .otc-accept-timer {
    color: #8a6230;
    background: rgba(209, 170, 103, 0.22);
}

.otc-accept-rows {
    margin-top: 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.otc-accept-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    font-size: 13px;
}

.otc-accept-row span:first-child {
    color: #9aa0aa;
}

.otc-accept-row span:last-child {
    text-align: right;
    font-weight: 700;
    word-break: break-word;
}

.otc-accept-row.is-emphasis {
    margin-top: 4px;
    padding-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    font-size: 14px;
}

body.light_theme .otc-accept-row span:first-child {
    color: #6b7280;
}

body.light_theme .otc-accept-row.is-emphasis {
    border-top-color: #ececec;
}

.otc-accept-note {
    margin: 14px 0 0;
    font-size: 12px;
    line-height: 1.4;
    color: #9aa0aa;
}

.otc-accept-error {
    margin: 10px 0 0;
    font-size: 13px;
    line-height: 1.4;
    color: #f87171;
}

.otc-accept-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
}

.otc-accept-submit,
.otc-accept-submit:hover,
.otc-accept-submit:focus {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 42px;
    border: 0;
    border-radius: 50px;
    background: #d1aa67;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
    cursor: pointer;
}

.otc-accept-submit.is-buy {
    background: #2bc287;
}

.otc-accept-submit.is-sell {
    background: #f74b60;
}

.otc-accept-submit:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.otc-accept-later {
    width: 100%;
    min-height: 40px;
    border: 0;
    border-radius: 50px;
    background: transparent;
    color: #c5c8ce;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}

body.light_theme .otc-accept-later {
    color: #4b5563;
}

.otc-current-ticket {
    position: relative;
}

.otc-current-ticket__btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: 0;
    background: transparent;
    color: inherit;
    padding: 0;
    cursor: pointer;
}

.otc-current-ticket__btn:disabled {
    cursor: default;
}

.otc-current-ticket__btn i {
    font-size: 18px;
    color: #d1aa67;
    line-height: 1;
}

.otc-current-ticket__menu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    z-index: 30;
    min-width: 280px;
    max-width: 100%;
    background: #1e2329;
    border: 1px solid #2b3139;
    border-radius: 8px;
    padding: 4px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.otc-current-ticket__menu button {
    display: grid;
    grid-template-columns: 1.1fr 0.6fr 1.3fr auto;
    gap: 8px;
    align-items: center;
    width: 100%;
    border: 0;
    background: transparent;
    color: #eaecef;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    padding: 8px 10px;
    border-radius: 6px;
    cursor: pointer;
}

.otc-current-ticket__menu button:hover,
.otc-current-ticket__menu button.is-current {
    background: rgba(209, 170, 103, 0.12);
    color: #e4c48a;
}

.otc-valid-until {
    color: #f0c079;
    font-weight: 700;
    background: rgba(209, 170, 103, 0.18);
    border-radius: 6px;
    padding: 1px 6px;
}

body.light_theme .otc-valid-until {
    color: #8a6230;
    background: rgba(209, 170, 103, 0.28);
}

.headingh6.mb-1 {
    font-weight: 600;
    font-size: 12px;
    margin-bottom: 3px !important;
}

.text-green.buybtn {
    color: #2BC287 !important;
}

.text-danger.sellbtn {
    color: #F74B60 !important;
}

.otc_tradingpage .buysell_heder .custom-tabs li.buy-tab a.active button {
    background-color: #2BC287 !important;
    color: #fff !important;
}

.otc_tradingpage .buysell_heder .custom-tabs li.sell-tab a.active button {
    background-color: #F74B60 !important;
    color: #fff !important;
}

button.btn.btn-secondary.cancel_order_btn {
    width: 100%;
    border-radius: 50px;
    color: #fff;
    background-color: #BFBFBF;
    border: none;
    font-size: 12px;
    font-weight: 600;
    padding: 11px;
}

a.view_market {
    color: #D1AA67;
    font-size: 12px;
    font-weight: 600;
}

.marketsnapshot .usdtpair {
    font-size: 12px;
    font-weight: 700;
}

.pricetxt {
    font-size: 12px;
    font-weight: 500;
}

.pricetxtsub.text-danger {
    font-weight: 500;
    color: #F43F5E !important;
    opacity: 1;
}

.text-muted.sublisttext {
    font-size: 11px;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.text-muted.sublisttext span {
    color: #ffffff;
    font-weight: 600;
    padding-left: 15px;
}

body.light_theme .text-muted.sublisttext span {
    color: #000;
}

.otc_tradingpage .trade_account_summary_assets {
    width: 100%;
    max-width: 100%;
    margin-top: 4px;
}

.otc_tradingpage .otc_hist_body {
    display: block;
    width: 100%;
    padding: 0 12px 16px;
}

.otc_tradingpage .otc_hist_scroll {
    width: 100%;
    overflow-x: auto;
}

.otc_tradingpage .otc_hist_table {
    width: 100%;
    border-collapse: collapse;
    min-width: 680px;
}

.otc_tradingpage .otc_hist_table--history,
.otc_tradingpage .otc_hist_table--active {
    min-width: 1100px;
}

.otc_tradingpage .otc_hist_table th {
    font-size: 11px;
    font-weight: 600;
    color: #848e9c;
    text-align: left;
    padding: 10px 8px;
    white-space: nowrap;
    border-bottom: 1px solid #2b3138;
}

.otc_tradingpage .otc_hist_table td {
    font-size: 12px;
    color: #eaecef;
    text-align: left;
    padding: 12px 8px;
    vertical-align: middle;
    white-space: nowrap;
}

.otc-rfq-menu-btn {
    border: 0;
    background: transparent;
    background-color: transparent;
    color: #eaecef;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 6px;
    padding: 0;
    line-height: 0;
    box-shadow: none;
}

.otc-rfq-menu-btn::before,
.otc-rfq-menu-btn::after {
    content: none;
    display: none;
}

.otc-rfq-menu-btn svg {
    display: block;
    background: none;
    box-shadow: none;
}

.otc-rfq-menu-btn:hover,
.otc-rfq-menu-btn[aria-expanded="true"] {
    background: transparent;
    background-color: transparent;
    color: #d1aa67;
}

body.light_theme .otc-rfq-menu-btn {
    color: #1e2329;
    background: transparent;
    background-color: transparent;
}

.otc-rfq-menu {
    position: fixed;
    z-index: 1200;
    min-width: 140px;
    background: #1e2329;
    border: 1px solid #2b3139;
    border-radius: 8px;
    padding: 4px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.otc-rfq-menu button {
    display: block;
    width: 100%;
    text-align: left;
    border: 0;
    background: transparent;
    color: #eaecef;
    font-size: 13px;
    font-weight: 600;
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
}

.otc-rfq-menu button:hover {
    background: rgba(209, 170, 103, 0.12);
    color: #e4c48a;
}

.otc-rfq-menu button.is-cancel:hover {
    color: #f6465d;
    background: rgba(246, 70, 93, 0.12);
}

.otc_tradingpage .otc_hist_table td .badge,
.otc_tradingpage .otc_hist_table td .badge:hover {
    position: static !important;
    transform: none !important;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    z-index: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    vertical-align: middle;
    line-height: 1;
    box-shadow: none;
    -webkit-backdrop-filter: none;
            backdrop-filter: none;
}

.otc_tradingpage .otc_hist_pair {
    display: flex;
    align-items: center;
    gap: 8px;
}

.otc_tradingpage .otc_hist_empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 220px;
    gap: 8px;
    color: #848e9c;
    font-size: 13px;
}

.otc_tradingpage .otc_hist_empty p {
    margin: 0;
}

.otc_tradingpage .otc_hist_mobile {
    display: none;
}

.otc_tradingpage .otc-rfq-card-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
}

body.light_theme .otc_tradingpage .otc_hist_table th {
    color: #6b7280;
    border-bottom-color: #e5e7eb;
}

body.light_theme .otc_tradingpage .otc_hist_table td {
    color: #111827;
}

body.light_theme .otc_tradingpage .otc_hist_empty {
    color: #6b7280;
}

.otc_tradingpage .trade_card.buysell_card.buysell_two {
    max-height: none;
    min-height: 0;
    overflow: visible;
    margin-bottom: 0px !important;
}

@media (min-width: 1201px) {
    .otc_tradingpage>.container-fluid>.row {
        align-items: stretch;
    }

    .otc_tradingpage .col-12.mmn_btm_minus_spc {
        display: flex;
        flex-direction: column;
        align-self: stretch;
    }

    .otc_tradingpage .mmn_btm_minus_spc>.bs_dropbox {
        flex: 1 1 auto;
        display: flex !important;
        flex-direction: column;
        min-height: 100%;
        height: auto;
    }

    .otc_tradingpage .mmn_btm_minus_spc>.bs_dropbox>.row {
        flex: 1 1 auto;
        height: 100%;
        margin: 0;
    }

    .otc_tradingpage .mmn_btm_minus_spc>.bs_dropbox .col-12 {
        display: flex;
        height: 100%;
    }

    .otc_tradingpage .bs_dropbox .trade_card.trade_chart.buysell_card {
        flex: 1 1 auto;
        width: 100%;
        height: 100%;
        min-height: 100%;
        max-height: none;
        position: relative;
        left: 0;
        overflow: auto;
    }
}

.textp {
    font-size: 11px;
    color: #848E9C;
}

body.light_theme .otc_tradingpage .trade_card {
    color: #000000fa;
}

.badge-soft-warning {
    background-color: rgba(217, 155, 0, 0.15) !important;
    color: #d99b00 !important;
    border-radius: 12px;
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 600;
    display: inline-block;
}

.otc-chart-view {
    min-height: 540px;
    height: 540px;
    width: 100%;
}

/* Spot Trade amount MAX button */
.otc_tradingpage .otc-amount-label-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
}

.otc_tradingpage .otc-amount-label-row label {
    margin-bottom: 0;
}

.otc_tradingpage .otc-amount-label-row .otc-balance-tip {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #848e9c;
    text-align: right;
}

.otc-balance-tip__icon {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: help;
}

.otc-balance-tip__text {
    display: none;
    position: absolute;
    right: 0;
    bottom: calc(100% + 8px);
    width: 230px;
    padding: 8px 10px;
    border-radius: 8px;
    background: #ffffff;
    color: #0f172a;
    border: 1px solid #e2e8f0;
    font-size: 11px;
    line-height: 1.4;
    font-weight: 600;
    text-align: left;
    white-space: normal;
    z-index: 8;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);
    pointer-events: none;
}

.otc-balance-tip__icon:hover .otc-balance-tip__text {
    display: block;
}

.otc_max_btn {
    border: none;
    background: transparent;
    color: #d1aa67;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    padding: 0 4px;
    line-height: 1;
    letter-spacing: 0.5px;
    border-radius: 4px;
    transition: all 0.15s ease;
}

.otc_max_btn:hover {
    color: #f0c079;
    background: rgba(209, 170, 103, 0.1);
}

/* Ensure Active and History tabs match Spot Trade and Figma exactly */
.position_order .spot_orders_primary_tabs li button {
    border: none;
    background: transparent;
    color: #848e9c;
    font-size: 14px;
    font-weight: 600;
    position: relative;
    font-family: "Inter", sans-serif;
    padding: 12px 18px 10px;
    margin: 0;
    cursor: pointer;
    transition: color 0.15s ease;
}

.position_order .spot_orders_primary_tabs li.active button {
    color: #ffffff;
    font-weight: 600;
}

body.light_theme .position_order .spot_orders_primary_tabs li.active button {
    color: #111827;
}

.position_order .spot_orders_primary_tabs li button::before {
    content: "";
    position: absolute;
    width: 32px;
    height: 3px;
    border-radius: 10px;
    background-color: #d1aa67;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: all 0.2s ease-in-out;
}

.position_order .spot_orders_primary_tabs li.active button::before {
    opacity: 1;
}

@media screen and (max-width:1200px) {

    .otc_tradingpage>.container-fluid>.row {
        display: flex;
        flex-direction: column;
    }

    .otc_tradingpage .midgraph_col {
        display: contents;
        width: 100%;
    }

    .otc_tradingpage .midgraph_col>.trade_card.overflow_card {
        order: 1;
        width: 100%;
    }

    .otc_tradingpage .midgraph_col>.trade_card.trade_chart {
        order: 2;
        width: 100%;
    }

    .otc_tradingpage .col-12.mmn_btm_minus_spc {
        order: 3;
        width: 100%;
        padding-left: 5px;
        margin-top: 0px;
    }

    .otc_tradingpage .trade_account_summary_assets {
        order: 4;
        width: 100%;
        margin-top: 5px;
    }

    .trade_card.p-3.marketsnapshot {
        width: 100%;
    }
}

@media screen and (max-width: 991px) {
    .otc_tradingpage .headline_left__lBBPY_leftmain {
        flex-wrap: wrap;
        gap: 8px 12px;
    }

    .otc_tradingpage .headline_left__lBBPY_rightmain {
        margin-left: 0 !important;
        margin-top: 6px;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .otc_tradingpage .midgraph_col .trade_card.trade_chart {
        height: auto !important;
        min-height: 0;
    }

    /* Mobile bottom-sheet pair popup overlay */
    .mobile-favourites-popup-overlay {
        display: flex !important;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999999999 !important;
    }

    .otc_tradingpage .otc_hist_body {
        display: none;
    }

    .otc_tradingpage .otc_hist_mobile {
        display: block;
        padding: 0 12px 16px;
    }

    .otc_tradingpage .trade_account_summary_assets .order_history_mobile_view {
        padding-bottom: 20px;
    }

    .otc_tradingpage {
        padding-bottom: 75px !important;
    }

    .otc_tradingpage .order_history_mobile_view .orders-mobCard {
        padding-bottom: 14px;
        border-bottom: 1px solid #2b313c;
        margin-bottom: 14px;
    }

    body.light_theme .otc_tradingpage .order_history_mobile_view .orders-mobCard {
        border-bottom-color: #e5e7eb;
    }

    .otc_tradingpage .bs_tab_row {
        position: fixed;
        bottom: 0;
        z-index: 9999;
        width: 100%;
        left: 0;
        padding: 12px 16px;
        background: #16171b;
        border-top: 1px solid #2b313c;
    }

    body.light_theme .otc_tradingpage .bs_tab_row {
        background: #ffffff;
        border-color: #e5e7eb;
    }

    .otc_tradingpage .bs_tab_row .btn {
        font-weight: 600;
        font-size: 15px;
        padding: 10px;
        border-radius: 6px;
    }

    .otc_tradingpage .bs_tab_row .btn-success {
        background-color: #2BC287 !important;
        border-color: #2BC287 !important;
        color: #fff !important;
    }

    .otc_tradingpage .bs_tab_row .btn-danger {
        background-color: #F74B60 !important;
        border-color: #F74B60 !important;
        color: #fff !important;
    }

    /* Modal bottom-sheet popup drawer for mobile OTC Buy/Sell */
    .otc_tradingpage .bs_dropbox:not(.d-none) {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100% !important;
        background-color: rgba(0, 0, 0, 0.65) !important;
        backdrop-filter: blur(4px) !important;
        -webkit-backdrop-filter: blur(4px) !important;
        z-index: 999999999 !important;
        display: flex !important;
        align-items: flex-end !important;
        justify-content: center !important;
    }

    body.light_theme .otc_tradingpage .bs_dropbox:not(.d-none) {
        background-color: rgb(255 255 255 / 65%) !important;
    }

    .otc_tradingpage .bs_dropbox:not(.d-none) .buysell_card {
        width: 100% !important;
        max-height: 85vh !important;
        min-height: auto !important;
        overflow-y: auto !important;
        border-radius: 16px 16px 0 0 !important;
        border-bottom: none !important;
        background-color: #121316 !important;
        box-shadow: 0 -5px 25px rgba(0, 0, 0, 0.5) !important;
        animation: slideUp 0.3s ease !important;
        padding: 16px !important;
    }

    body.light_theme .otc_tradingpage .bs_dropbox:not(.d-none) .buysell_card {
        background-color: #ffffff !important;
        box-shadow: 0 -5px 25px rgba(0, 0, 0, 0.15) !important;
    }

    @keyframes slideUp {
        from {
            transform: translateY(100%);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

}

@media screen and (min-width: 992px) {
    .otc_tradingpage .bs_dropbox {
        display: block !important;
        position: static !important;
        width: 100% !important;
        background: transparent !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
        z-index: auto !important;
    }


}

/* Coin Icons Styling */
.otc_tradingpage .round_img,
.round_img {
    border-radius: 50% !important;
    object-fit: cover !important;
    vertical-align: middle !important;
}

.otc_tradingpage .spot_orders_table td img.round_img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.otc_tradingpage .headline_bigName__dspVW img.round_img {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.otc_tradingpage .marketsnapshot img.round_img {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.otc-amount-error,
.otc-amount-warning {
    margin: 6px 0 0;
    font-size: 12px;
    line-height: 1.4;
}

.otc-amount-error {
    color: #f07178;
}

body.light_theme .trade_favourites_lft.is-open {
    background-color: #fdfdfd;
}

/* Chart pair menu on OTC only: height follows the pair rows. */
/* .otc_tradingpage .trade_favourites_lft.is-open {
    height: auto;
    max-height: calc(100vh - 120px);
} */

/* .otc_tradingpage .trade_favourites_lft.is-open .spotLists,
.otc_tradingpage .trade_favourites_lft .spotLists {
    height: auto;
    max-height: calc(100vh - 120px);
} */

.otc_tradingpage .trade_favourites_lft.is-open .price_card,
.otc_tradingpage .trade_favourites_lft.is-open .price_card.table-responsive,
.otc_tradingpage .trade_favourites_lft .table-responsive {
    flex: none;
    height: auto;
    min-height: 0;
    max-height: calc(100vh - 220px);
    overflow: auto;
}

.otc-amount-warning {
    color: #e6b450;
}

body.light_theme .otc-amount-warning {
    color: #9a6b00;
}

.buysellform .input-group .form-control.otc-amount-input {
    flex: 1 1 auto;
    min-width: 0;
    cursor: text;
}

.buysellform .input-group .form-control.otc-amount-input::placeholder {
    color: rgba(255, 255, 255, 0.35) !important;
    font-weight: 400;
    opacity: 1;
}

.buysellform .input-group .form-control.otc-amount-input:focus::placeholder {
    color: transparent !important;
}

body.light_theme .buysellform .input-group .form-control.otc-amount-input::placeholder {
    color: #94a3b8 !important;
}

@media screen and (max-width:767px) {

    .otc-header-pair__symbol {
        font-size: 13px;
    }

    .otc_tradingpage .round_img,
    .round_img {
        width: 24px !important;
        height: 24px !important;
        min-width: 24px;
    }

    .trade_card.trade_chart.buysell_card.buysell_two ul.favorites_list_tabs li button {
        font-size: 12px;
    }

    .otc_tradingpage .otc-header-pair .trade_favourites_lft {
        width: min(440px, 84vw) !important;
    }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/OtcDesk/otc_rfq.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;IACI,qDAAqD;IACrD,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,2CAA2C;IAC3C,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,0BAA0B;IAC1B,kCAAkC;IAClC,eAAe;IACf,sDAAsD;AAC1D;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,8BAA8B;IAC9B,8BAA8B;IAC9B,6DAA6D;AACjE;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,gDAAgD;IAChD,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;AACxC;;AAEA;IACI,gDAAgD;IAChD,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,kCAAkC;IAClC,wBAAwB;IACxB,4BAA4B;IAC5B,sCAAsC;IACtC,uDAAuD;IACvD,4BAA4B;IAC5B,wBAAwB;IACxB,kBAAkB;IAClB,iCAAiC;IACjC,4BAA4B;IAC5B,2DAA2D;IAC3D,sCAAsC;IACtC,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;IAC/B,0GAA0G;IAC1G,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,sCAAsC;IACtC,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,6BAA6B;IAC7B,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;IAC3B,kCAAkC;IAClC,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,sDAAsD;IACtD,6BAA6B;IAC7B,4BAA4B;IAC5B,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,uDAAuD;AAC3D;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,qCAAqC;IACrC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,qBAAqB;IACrB,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;;;;;IAKI,oCAAoC;IACpC,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,iCAAiC;IACjC,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,2CAA2C;IAC3C,mBAAmB;IACnB,2CAA2C;IAC3C,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+CAA+C;IAC/C,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,6CAA6C;IAC7C,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,6BAA6B;IAC7B,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;IACvB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mCAAmC;AACvC;;AAEA;;IAEI,2BAA2B;IAC3B,0BAA0B;IAC1B,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,6BAAqB;YAArB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,wBAAwB;QACxB,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,OAAO;QACP,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;AACf;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA,sEAAsE;AACtE;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,QAAQ;QACR,WAAW;QACX,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,WAAW;QACX,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA,2CAA2C;IAC3C;QACI,wBAAwB;QACxB,eAAe;QACf,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,8BAA8B;IAClC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,oBAAoB;QACpB,gCAAgC;QAChC,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,SAAS;QACT,aAAa;QACb,WAAW;QACX,OAAO;QACP,kBAAkB;QAClB,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,oCAAoC;QACpC,gCAAgC;QAChC,sBAAsB;IAC1B;;IAEA;QACI,oCAAoC;QACpC,gCAAgC;QAChC,sBAAsB;IAC1B;;IAEA,4DAA4D;IAC5D;QACI,0BAA0B;QAC1B,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;QACpB,sBAAsB;QACtB,gDAAgD;QAChD,qCAAqC;QACrC,6CAA6C;QAC7C,6BAA6B;QAC7B,wBAAwB;QACxB,gCAAgC;QAChC,kCAAkC;IACtC;;IAEA;QACI,mDAAmD;IACvD;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,2BAA2B;QAC3B,2BAA2B;QAC3B,uCAAuC;QACvC,8BAA8B;QAC9B,oCAAoC;QACpC,qDAAqD;QACrD,uCAAuC;QACvC,wBAAwB;IAC5B;;IAEA;QACI,oCAAoC;QACpC,sDAAsD;IAC1D;;IAEA;QACI;YACI,2BAA2B;YAC3B,UAAU;QACd;;QAEA;YACI,wBAAwB;YACxB,UAAU;QACd;IACJ;;AAEJ;;AAEA;IACI;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,sBAAsB;QACtB,kCAAkC;QAClC,gCAAgC;QAChC,wCAAwC;QACxC,wBAAwB;IAC5B;;;AAGJ;;AAEA,uBAAuB;AACvB;;IAEI,6BAA6B;IAC7B,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,+DAA+D;AAC/D;;;GAGG;;AAEH;;;;GAIG;;AAEH;;;IAGI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;;QAEI,sBAAsB;QACtB,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kCAAkC;IACtC;;AAEJ","sourcesContent":["/* Minimal helper styling for OTC RFQ Page - follows Spot Trade theme */\n\n.badge-soft-success {\n    background-color: rgba(14, 203, 129, 0.15) !important;\n    color: #0ecb81 !important;\n    border-radius: 12px;\n    padding: 3px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    display: inline-block;\n}\n\n.badge-soft-danger {\n    background-color: rgba(246, 70, 93, 0.15) !important;\n    color: #f6465d !important;\n    border-radius: 12px;\n    padding: 3px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    display: inline-block;\n}\n\n.trade_card.trade_chart.buysell_card.buysell_two .small {\n    opacity: 1;\n}\n\n.otc_tradingpage .col-12.mmn_btm_minus_spc {\n    width: 21%;\n    padding-left: 1px;\n}\n\n.otc_tradingpage .midgraph_col {\n    width: 79%;\n}\n\n.otc_tradingpage .trade_card.p-2.overflow_card.mb-1 {\n    width: 100%;\n    height: 57px;\n}\n\n.trade_card.p-3.marketsnapshot {\n    width: 25.8%;\n}\n\n.gradebtn {\n    color: #D1AA67;\n    background: rgb(240 240 240 / 7%);\n    font-weight: 600;\n    border-radius: 16px;\n    font-size: 11px;\n    gap: 5px;\n}\n\nbody.light_theme .gradebtn {\n    background: #F0F0F0;\n}\n\n.otc_tradingpage .mmn_btm_minus_spc h5.mb-0 {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.otc_tradingpage .buysell_heder {\n    padding: 3px 0px 8px 0px !important;\n}\n\n.otc-pair-menu {\n    position: relative;\n    margin-bottom: 12px;\n}\n\n.otc-pair-trigger {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(255, 255, 255, 0.04);\n    color: #fff;\n    border-radius: 8px;\n    padding: 8px 10px;\n    text-align: left;\n    cursor: pointer;\n}\n\nbody.light_theme .otc-pair-trigger {\n    color: #111;\n    background: #f7f7f7;\n    border-color: #e5e7eb;\n}\n\n.otc-pair-menu {\n    z-index: 30;\n}\n\n.otc_tradingpage .trade_card.buysell_card.buysell_two,\n.otc_tradingpage .buysellform {\n    overflow: visible;\n}\n\n.otc-pair-menu .otc-graph-pairs {\n    display: block;\n    position: absolute;\n    z-index: 40;\n    left: 0;\n    right: 0;\n    top: calc(100% + 4px);\n    height: auto;\n    max-height: 420px;\n    overflow: auto;\n    background: #1e2329;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n    padding: 8px 8px 4px;\n}\n\n.otc-pair-search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 8px;\n    padding: 8px 10px;\n    margin-bottom: 12px;\n}\n\n.otc-pair-search i {\n    color: #848e9c;\n}\n\n.otc-pair-search input {\n    flex: 1;\n    border: 0;\n    outline: 0;\n    background: transparent;\n    color: inherit;\n    font-size: 13px;\n}\n\n.otc-header-pair {\n    position: relative;\n}\n\n.otc-header-pair__btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    padding: 0;\n    cursor: pointer;\n    text-align: left;\n}\n\n.otc-header-pair__text {\n    display: flex;\n    flex-direction: column;\n    line-height: 1.15;\n}\n\n.otc-header-pair__symbol {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.otc-header-pair__name {\n    font-size: 11px;\n    color: #848e9c;\n}\n\n.trade_card.buysell_card.buysell_two .spotLists {\n    box-shadow: none;\n}\n\n.otc_tradingpage .otc-pair-drawer-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.55);\n    backdrop-filter: blur(3px);\n    -webkit-backdrop-filter: blur(3px);\n    z-index: 999998;\n    animation: otcDrawerBackdropFadeIn 0.35s ease forwards;\n}\n\n@keyframes otcDrawerBackdropFadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.otc_tradingpage .otc-header-pair .trade_pairs_drawer_header {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    padding: 0 0 16px 0 !important;\n    margin-bottom: 12px !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_pairs_drawer_title {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #eaecef !important;\n    letter-spacing: -0.2px !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_pairs_drawer_close {\n    border: 0 !important;\n    background: rgba(255, 255, 255, 0.08) !important;\n    color: #848e9c !important;\n    width: 32px !important;\n    height: 32px !important;\n    border-radius: 8px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    font-size: 20px !important;\n    cursor: pointer !important;\n    transition: all 0.2s ease !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_pairs_drawer_close:hover {\n    background: rgba(255, 255, 255, 0.16) !important;\n    color: #ffffff !important;\n    transform: scale(1.05) !important;\n}\n\n.trade-wrapper .letsidebar_tradetbl .orderbook-table th {\n    background-color: #212227 !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft {\n    position: fixed !important;\n    top: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    left: auto !important;\n    margin: 0 !important;\n    width: min(440px, 94vw) !important;\n    height: 100vh !important;\n    max-height: 100vh !important;\n    background-color: #212328f0 !important;\n    box-shadow: -10px 0 36px rgba(0, 0, 0, 0.55) !important;\n    z-index: 99999999 !important;\n    display: flex !important;\n    border-radius: 0px;\n    flex-direction: column !important;\n    padding: 20px 8px !important;\n    border-left: 1px solid rgba(255, 255, 255, 0.08) !important;\n    transform: translateX(100%) !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n    pointer-events: none !important;\n    transition: transform 0.45s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.35s ease, visibility 0.45s !important;\n    overflow: hidden !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft.is-open {\n    transform: translateX(0) !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n    pointer-events: auto !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft.is-collapsed {\n    display: flex !important;\n    transform: translateX(100%) !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n    pointer-events: none !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .spotLists {\n    display: flex !important;\n    flex-direction: column !important;\n    position: relative !important;\n    width: 100% !important;\n    max-width: none !important;\n    height: 100% !important;\n    max-height: 100% !important;\n    min-height: 0 !important;\n    overflow: hidden !important;\n    background: transparent !important;\n    border: none !important;\n    padding: 0 !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search {\n    flex: 0 0 auto !important;\n    margin-bottom: 12px !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search .ivu-input {\n    background: #2b313c !important;\n    border: 1px solid rgba(255, 255, 255, 0.08) !important;\n    border-radius: 8px !important;\n    padding: 8px 12px !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    height: 40px !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search .ivu-input input {\n    background: transparent !important;\n    border: none !important;\n    color: #eaecef !important;\n    font-size: 13px !important;\n    width: 100% !important;\n    outline: none !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .favorites_list_tabs {\n    flex: 0 0 auto !important;\n    display: flex !important;\n    gap: 6px !important;\n    padding: 0 0 10px 0 !important;\n    margin: 0 !important;\n    list-style: none !important;\n    overflow-x: auto !important;\n    scrollbar-width: none !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .favorites_list_tabs::-webkit-scrollbar {\n    display: none !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card,\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card.table-responsive {\n    flex: 1 1 auto !important;\n    height: 100% !important;\n    min-height: 0 !important;\n    max-height: none !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    padding-right: 2px !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card::-webkit-scrollbar {\n    width: 4px;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 4px;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr {\n    cursor: pointer !important;\n    transition: background 0.18s ease;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr:hover {\n    background: rgba(255, 255, 255, 0.05) !important;\n}\n\n.otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr.active {\n    background: rgba(240, 185, 11, 0.12) !important;\n}\n\nbody.light_theme .otc_tradingpage .otc-pair-drawer-backdrop {\n    background: rgb(255 255 255 / 35%);\n}\n\nbody.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft {\n    background-color: #ffffff !important;\n    border-left: 1px solid #e6e8ea !important;\n    box-shadow: -10px 0 36px rgba(0, 0, 0, 0.15) !important;\n}\n\nbody.light_theme .otc_tradingpage .otc-header-pair .trade_pairs_drawer_header {\n    border-bottom: 1px solid #edf0f3 !important;\n}\n\nbody.light_theme .otc_tradingpage .otc-header-pair .trade_pairs_drawer_title {\n    color: #1e2329 !important;\n}\n\nbody.light_theme .otc_tradingpage .otc-header-pair .trade_pairs_drawer_close {\n    background: #f4f5f7 !important;\n    color: #707a8a !important;\n}\n\nbody.light_theme .otc_tradingpage .otc-header-pair .trade_pairs_drawer_close:hover {\n    background: #e9eaec !important;\n    color: #1e2329 !important;\n}\n\nbody.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search .ivu-input {\n    background: #f5f6f8 !important;\n    border: 1px solid #e6e8ea !important;\n}\n\nbody.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft .spot-list-search .ivu-input input {\n    color: #1e2329 !important;\n}\n\nbody.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr:hover {\n    background: #f7f8fa !important;\n}\n\nbody.light_theme .otc_tradingpage .otc-header-pair .trade_favourites_lft .price_card_body tr.active {\n    background: rgba(240, 185, 11, 0.12) !important;\n}\n\n.otc-pair-recent__head,\n.otc-pair-tabs {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 8px;\n    color: #848e9c;\n    font-size: 12px;\n}\n\n.otc-pair-recent__head {\n    justify-content: space-between;\n}\n\n.otc-pair-recent__head button,\n.otc-pair-tabs button {\n    border: 0;\n    background: transparent;\n    color: #848e9c;\n    padding: 0;\n    cursor: pointer;\n}\n\n.otc-pair-tabs button.is-active {\n    color: #fff;\n    box-shadow: inset 0 -2px 0 #f0b90b;\n}\n\n.otc-pair-recent__chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.otc-pair-recent__chips button {\n    border: 0;\n    background: rgba(255, 255, 255, 0.06);\n    color: #eaecef;\n    border-radius: 6px;\n    padding: 4px 8px;\n    font-size: 12px;\n    cursor: pointer;\n}\n\n.otc-pair-result {\n    display: grid;\n    grid-template-columns: 16px 18px 1fr auto auto;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    border: 0;\n    background: transparent;\n    color: #eaecef;\n    border-radius: 6px;\n    padding: 7px 4px;\n    text-align: left;\n    cursor: pointer;\n}\n\n.otc-pair-result:hover,\n.otc-pair-result.is-active {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.otc-pair-result .ri-star-fill {\n    color: #f0b90b;\n}\n\n.otc-pair-result__rank,\n.otc-pair-result__symbol {\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.otc-pair-result__price,\n.otc-pair-result__change {\n    font-size: 12px;\n    font-variant-numeric: tabular-nums;\n}\n\n.otc-pair-result__change.is-up {\n    color: #0ecb81;\n}\n\n.otc-pair-result__change.is-down {\n    color: #f6465d;\n}\n\nbody.light_theme .otc-pair-tabs button.is-active,\nbody.light_theme .otc-pair-result {\n    color: #111;\n}\n\n.otc-pair-menu .otc-graph-pairs .spot-list-search {\n    margin-bottom: 8px;\n}\n\n.otc-pair-menu .otc-graph-pairs .favorites_list_tabs {\n    margin: 0 0 8px;\n}\n\n.otc-pair-menu .otc-graph-pairs .price_card,\n.otc-pair-menu .otc-graph-pairs .table-responsive {\n    height: auto;\n    min-height: 0;\n    max-height: none;\n    overflow: visible;\n}\n\nbody.light_theme .otc-pair-menu .otc-graph-pairs {\n    background: #fff;\n    border-color: #e5e7eb;\n    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n}\n\n.otc-active-pairs-list {\n    position: absolute;\n    z-index: 30;\n    left: 0;\n    right: 0;\n    top: calc(100% + 4px);\n    background: #1e2329;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 10px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n    padding: 4px;\n}\n\n.otc-active-pairs-empty {\n    font-size: 12px;\n    color: #848e9c;\n    padding: 8px 0;\n}\n\n.otc-active-pairs-list {\n    max-height: 220px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\nbody.light_theme .otc-active-pairs-list {\n    background: #fff;\n    border-color: #e5e7eb;\n    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n}\n\n.otc-active-pair {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    border: 0;\n    background: transparent;\n    color: #fff;\n    border-radius: 8px;\n    padding: 6px 8px;\n    text-align: left;\n    cursor: pointer;\n}\n\n.otc-active-pair:hover,\n.otc-active-pair.is-active {\n    background: rgba(209, 170, 103, 0.16);\n}\n\n.otc-active-pair-symbol {\n    flex: 1;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.otc-active-pair-price {\n    font-size: 12px;\n    font-variant-numeric: tabular-nums;\n}\n\n.otc-active-pair-price.is-up {\n    color: #0ecb81;\n}\n\n.otc-active-pair-price.is-down {\n    color: #f6465d;\n}\n\nbody.light_theme .otc-active-pair {\n    color: #111;\n}\n\n.otc_tradingpage a.requestquotebtn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n}\n\n.otc_tradingpage .requestquotebtn,\n.otc_tradingpage .requestquotebtn:hover,\n.otc_tradingpage .requestquotebtn:focus,\n.otc_tradingpage .requestquotebtn:active,\n.otc_tradingpage .requestquotebtn:disabled {\n    background-color: #D1AA67 !important;\n    border: none !important;\n    font-size: 13px;\n    min-height: 40px;\n    font-weight: 500;\n    border-radius: 50px;\n    color: #fff !important;\n    box-shadow: none !important;\n    opacity: 1;\n}\n\n.otc_tradingpage .requestquotebtn:hover,\n.otc_tradingpage .requestquotebtn:focus,\n.otc_tradingpage .requestquotebtn:active {\n    background-color: #c49b58 !important;\n}\n\n.otc_tradingpage .requestquotebtn:disabled {\n    opacity: 0.7;\n}\n\n.otc_tradingpage h6.font-weight-bold.mb-0 {\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.listotctrade span.font-weight-bold {\n    color: #fff;\n    opacity: 1;\n    font-weight: 600;\n}\n\nbody.light_theme .listotctrade span.font-weight-bold {\n    color: #000;\n\n}\n\n.quotedeskawaiting {\n    width: 100%;\n    background-color: rgb(237 237 237 / 10%);\n    padding: 12px;\n    border-radius: 12px;\n    margin: 16px 0px;\n}\n\nbody.light_theme .quotedeskawaiting {\n    background-color: #EDEDED;\n}\n\n.otc-accept-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 100000000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    background: rgba(8, 10, 16, 0.72);\n    backdrop-filter: blur(4px);\n}\n\n.otc-accept-modal {\n    width: min(440px, 100%);\n    max-height: min(92vh, 760px);\n    overflow: auto;\n    background: #1b1d24;\n    color: #fff;\n    border: 1px solid rgba(209, 170, 103, 0.35);\n    border-radius: 16px;\n    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n    padding: 20px 20px 16px;\n}\n\nbody.light_theme .otc-accept-modal {\n    background: #fff;\n    color: #111;\n    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);\n}\n\n.otc-accept-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.otc-accept-kicker {\n    margin: 0 0 2px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: #d1aa67;\n}\n\n.otc-accept-head h2 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.otc-accept-close {\n    width: 32px;\n    height: 32px;\n    border: 0;\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.08);\n    color: #c5c8ce;\n    font-size: 22px;\n    line-height: 1;\n    cursor: pointer;\n}\n\nbody.light_theme .otc-accept-close {\n    background: #f0f0f0;\n    color: #444;\n}\n\n.otc-accept-lead {\n    margin: 12px 0 0;\n    font-size: 13px;\n    line-height: 1.45;\n    color: #c5c8ce;\n}\n\nbody.light_theme .otc-accept-lead,\nbody.light_theme .otc-accept-note {\n    color: #4b5563;\n}\n\n.otc-accept-timer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    margin-top: 14px;\n    padding: 10px 12px;\n    border-radius: 10px;\n    background: rgba(209, 170, 103, 0.16);\n    color: #f0c079;\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.otc-accept-timer span {\n    font-weight: 600;\n    font-size: 12px;\n}\n\n.otc-accept-timer.is-expired {\n    background: rgba(246, 70, 93, 0.16);\n    color: #f6465d;\n}\n\nbody.light_theme .otc-accept-timer {\n    color: #8a6230;\n    background: rgba(209, 170, 103, 0.22);\n}\n\n.otc-accept-rows {\n    margin-top: 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.otc-accept-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n    font-size: 13px;\n}\n\n.otc-accept-row span:first-child {\n    color: #9aa0aa;\n}\n\n.otc-accept-row span:last-child {\n    text-align: right;\n    font-weight: 700;\n    word-break: break-word;\n}\n\n.otc-accept-row.is-emphasis {\n    margin-top: 4px;\n    padding-top: 10px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    font-size: 14px;\n}\n\nbody.light_theme .otc-accept-row span:first-child {\n    color: #6b7280;\n}\n\nbody.light_theme .otc-accept-row.is-emphasis {\n    border-top-color: #ececec;\n}\n\n.otc-accept-note {\n    margin: 14px 0 0;\n    font-size: 12px;\n    line-height: 1.4;\n    color: #9aa0aa;\n}\n\n.otc-accept-error {\n    margin: 10px 0 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: #f87171;\n}\n\n.otc-accept-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 16px;\n}\n\n.otc-accept-submit,\n.otc-accept-submit:hover,\n.otc-accept-submit:focus {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    min-height: 42px;\n    border: 0;\n    border-radius: 50px;\n    background: #d1aa67;\n    color: #fff;\n    font-size: 13px;\n    font-weight: 700;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.otc-accept-submit.is-buy {\n    background: #2bc287;\n}\n\n.otc-accept-submit.is-sell {\n    background: #f74b60;\n}\n\n.otc-accept-submit:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n}\n\n.otc-accept-later {\n    width: 100%;\n    min-height: 40px;\n    border: 0;\n    border-radius: 50px;\n    background: transparent;\n    color: #c5c8ce;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\nbody.light_theme .otc-accept-later {\n    color: #4b5563;\n}\n\n.otc-current-ticket {\n    position: relative;\n}\n\n.otc-current-ticket__btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    padding: 0;\n    cursor: pointer;\n}\n\n.otc-current-ticket__btn:disabled {\n    cursor: default;\n}\n\n.otc-current-ticket__btn i {\n    font-size: 18px;\n    color: #d1aa67;\n    line-height: 1;\n}\n\n.otc-current-ticket__menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    z-index: 30;\n    min-width: 280px;\n    max-width: 100%;\n    background: #1e2329;\n    border: 1px solid #2b3139;\n    border-radius: 8px;\n    padding: 4px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n.otc-current-ticket__menu button {\n    display: grid;\n    grid-template-columns: 1.1fr 0.6fr 1.3fr auto;\n    gap: 8px;\n    align-items: center;\n    width: 100%;\n    border: 0;\n    background: transparent;\n    color: #eaecef;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 8px 10px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.otc-current-ticket__menu button:hover,\n.otc-current-ticket__menu button.is-current {\n    background: rgba(209, 170, 103, 0.12);\n    color: #e4c48a;\n}\n\n.otc-valid-until {\n    color: #f0c079;\n    font-weight: 700;\n    background: rgba(209, 170, 103, 0.18);\n    border-radius: 6px;\n    padding: 1px 6px;\n}\n\nbody.light_theme .otc-valid-until {\n    color: #8a6230;\n    background: rgba(209, 170, 103, 0.28);\n}\n\n.headingh6.mb-1 {\n    font-weight: 600;\n    font-size: 12px;\n    margin-bottom: 3px !important;\n}\n\n.text-green.buybtn {\n    color: #2BC287 !important;\n}\n\n.text-danger.sellbtn {\n    color: #F74B60 !important;\n}\n\n.otc_tradingpage .buysell_heder .custom-tabs li.buy-tab a.active button {\n    background-color: #2BC287 !important;\n    color: #fff !important;\n}\n\n.otc_tradingpage .buysell_heder .custom-tabs li.sell-tab a.active button {\n    background-color: #F74B60 !important;\n    color: #fff !important;\n}\n\nbutton.btn.btn-secondary.cancel_order_btn {\n    width: 100%;\n    border-radius: 50px;\n    color: #fff;\n    background-color: #BFBFBF;\n    border: none;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 11px;\n}\n\na.view_market {\n    color: #D1AA67;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.marketsnapshot .usdtpair {\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.pricetxt {\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.pricetxtsub.text-danger {\n    font-weight: 500;\n    color: #F43F5E !important;\n    opacity: 1;\n}\n\n.text-muted.sublisttext {\n    font-size: 11px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.text-muted.sublisttext span {\n    color: #ffffff;\n    font-weight: 600;\n    padding-left: 15px;\n}\n\nbody.light_theme .text-muted.sublisttext span {\n    color: #000;\n}\n\n.otc_tradingpage .trade_account_summary_assets {\n    width: 100%;\n    max-width: 100%;\n    margin-top: 4px;\n}\n\n.otc_tradingpage .otc_hist_body {\n    display: block;\n    width: 100%;\n    padding: 0 12px 16px;\n}\n\n.otc_tradingpage .otc_hist_scroll {\n    width: 100%;\n    overflow-x: auto;\n}\n\n.otc_tradingpage .otc_hist_table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 680px;\n}\n\n.otc_tradingpage .otc_hist_table--history,\n.otc_tradingpage .otc_hist_table--active {\n    min-width: 1100px;\n}\n\n.otc_tradingpage .otc_hist_table th {\n    font-size: 11px;\n    font-weight: 600;\n    color: #848e9c;\n    text-align: left;\n    padding: 10px 8px;\n    white-space: nowrap;\n    border-bottom: 1px solid #2b3138;\n}\n\n.otc_tradingpage .otc_hist_table td {\n    font-size: 12px;\n    color: #eaecef;\n    text-align: left;\n    padding: 12px 8px;\n    vertical-align: middle;\n    white-space: nowrap;\n}\n\n.otc-rfq-menu-btn {\n    border: 0;\n    background: transparent;\n    background-color: transparent;\n    color: #eaecef;\n    width: 28px;\n    height: 28px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 6px;\n    padding: 0;\n    line-height: 0;\n    box-shadow: none;\n}\n\n.otc-rfq-menu-btn::before,\n.otc-rfq-menu-btn::after {\n    content: none;\n    display: none;\n}\n\n.otc-rfq-menu-btn svg {\n    display: block;\n    background: none;\n    box-shadow: none;\n}\n\n.otc-rfq-menu-btn:hover,\n.otc-rfq-menu-btn[aria-expanded=\"true\"] {\n    background: transparent;\n    background-color: transparent;\n    color: #d1aa67;\n}\n\nbody.light_theme .otc-rfq-menu-btn {\n    color: #1e2329;\n    background: transparent;\n    background-color: transparent;\n}\n\n.otc-rfq-menu {\n    position: fixed;\n    z-index: 1200;\n    min-width: 140px;\n    background: #1e2329;\n    border: 1px solid #2b3139;\n    border-radius: 8px;\n    padding: 4px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n.otc-rfq-menu button {\n    display: block;\n    width: 100%;\n    text-align: left;\n    border: 0;\n    background: transparent;\n    color: #eaecef;\n    font-size: 13px;\n    font-weight: 600;\n    padding: 8px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.otc-rfq-menu button:hover {\n    background: rgba(209, 170, 103, 0.12);\n    color: #e4c48a;\n}\n\n.otc-rfq-menu button.is-cancel:hover {\n    color: #f6465d;\n    background: rgba(246, 70, 93, 0.12);\n}\n\n.otc_tradingpage .otc_hist_table td .badge,\n.otc_tradingpage .otc_hist_table td .badge:hover {\n    position: static !important;\n    transform: none !important;\n    top: auto;\n    left: auto;\n    right: auto;\n    bottom: auto;\n    z-index: auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    vertical-align: middle;\n    line-height: 1;\n    box-shadow: none;\n    backdrop-filter: none;\n}\n\n.otc_tradingpage .otc_hist_pair {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.otc_tradingpage .otc_hist_empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 220px;\n    gap: 8px;\n    color: #848e9c;\n    font-size: 13px;\n}\n\n.otc_tradingpage .otc_hist_empty p {\n    margin: 0;\n}\n\n.otc_tradingpage .otc_hist_mobile {\n    display: none;\n}\n\n.otc_tradingpage .otc-rfq-card-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 4px;\n}\n\nbody.light_theme .otc_tradingpage .otc_hist_table th {\n    color: #6b7280;\n    border-bottom-color: #e5e7eb;\n}\n\nbody.light_theme .otc_tradingpage .otc_hist_table td {\n    color: #111827;\n}\n\nbody.light_theme .otc_tradingpage .otc_hist_empty {\n    color: #6b7280;\n}\n\n.otc_tradingpage .trade_card.buysell_card.buysell_two {\n    max-height: none;\n    min-height: 0;\n    overflow: visible;\n    margin-bottom: 0px !important;\n}\n\n@media (min-width: 1201px) {\n    .otc_tradingpage>.container-fluid>.row {\n        align-items: stretch;\n    }\n\n    .otc_tradingpage .col-12.mmn_btm_minus_spc {\n        display: flex;\n        flex-direction: column;\n        align-self: stretch;\n    }\n\n    .otc_tradingpage .mmn_btm_minus_spc>.bs_dropbox {\n        flex: 1 1 auto;\n        display: flex !important;\n        flex-direction: column;\n        min-height: 100%;\n        height: auto;\n    }\n\n    .otc_tradingpage .mmn_btm_minus_spc>.bs_dropbox>.row {\n        flex: 1 1 auto;\n        height: 100%;\n        margin: 0;\n    }\n\n    .otc_tradingpage .mmn_btm_minus_spc>.bs_dropbox .col-12 {\n        display: flex;\n        height: 100%;\n    }\n\n    .otc_tradingpage .bs_dropbox .trade_card.trade_chart.buysell_card {\n        flex: 1 1 auto;\n        width: 100%;\n        height: 100%;\n        min-height: 100%;\n        max-height: none;\n        position: relative;\n        left: 0;\n        overflow: auto;\n    }\n}\n\n.textp {\n    font-size: 11px;\n    color: #848E9C;\n}\n\nbody.light_theme .otc_tradingpage .trade_card {\n    color: #000000fa;\n}\n\n.badge-soft-warning {\n    background-color: rgba(217, 155, 0, 0.15) !important;\n    color: #d99b00 !important;\n    border-radius: 12px;\n    padding: 3px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    display: inline-block;\n}\n\n.otc-chart-view {\n    min-height: 540px;\n    height: 540px;\n    width: 100%;\n}\n\n/* Spot Trade amount MAX button */\n.otc_tradingpage .otc-amount-label-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 6px;\n}\n\n.otc_tradingpage .otc-amount-label-row label {\n    margin-bottom: 0;\n}\n\n.otc_tradingpage .otc-amount-label-row .otc-balance-tip {\n    margin-left: auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    color: #848e9c;\n    text-align: right;\n}\n\n.otc-balance-tip__icon {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    cursor: help;\n}\n\n.otc-balance-tip__text {\n    display: none;\n    position: absolute;\n    right: 0;\n    bottom: calc(100% + 8px);\n    width: 230px;\n    padding: 8px 10px;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #0f172a;\n    border: 1px solid #e2e8f0;\n    font-size: 11px;\n    line-height: 1.4;\n    font-weight: 600;\n    text-align: left;\n    white-space: normal;\n    z-index: 8;\n    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);\n    pointer-events: none;\n}\n\n.otc-balance-tip__icon:hover .otc-balance-tip__text {\n    display: block;\n}\n\n.otc_max_btn {\n    border: none;\n    background: transparent;\n    color: #d1aa67;\n    font-size: 12px;\n    font-weight: 700;\n    cursor: pointer;\n    padding: 0 4px;\n    line-height: 1;\n    letter-spacing: 0.5px;\n    border-radius: 4px;\n    transition: all 0.15s ease;\n}\n\n.otc_max_btn:hover {\n    color: #f0c079;\n    background: rgba(209, 170, 103, 0.1);\n}\n\n/* Ensure Active and History tabs match Spot Trade and Figma exactly */\n.position_order .spot_orders_primary_tabs li button {\n    border: none;\n    background: transparent;\n    color: #848e9c;\n    font-size: 14px;\n    font-weight: 600;\n    position: relative;\n    font-family: \"Inter\", sans-serif;\n    padding: 12px 18px 10px;\n    margin: 0;\n    cursor: pointer;\n    transition: color 0.15s ease;\n}\n\n.position_order .spot_orders_primary_tabs li.active button {\n    color: #ffffff;\n    font-weight: 600;\n}\n\nbody.light_theme .position_order .spot_orders_primary_tabs li.active button {\n    color: #111827;\n}\n\n.position_order .spot_orders_primary_tabs li button::before {\n    content: \"\";\n    position: absolute;\n    width: 32px;\n    height: 3px;\n    border-radius: 10px;\n    background-color: #d1aa67;\n    bottom: -1px;\n    left: 50%;\n    transform: translateX(-50%);\n    opacity: 0;\n    transition: all 0.2s ease-in-out;\n}\n\n.position_order .spot_orders_primary_tabs li.active button::before {\n    opacity: 1;\n}\n\n@media screen and (max-width:1200px) {\n\n    .otc_tradingpage>.container-fluid>.row {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .otc_tradingpage .midgraph_col {\n        display: contents;\n        width: 100%;\n    }\n\n    .otc_tradingpage .midgraph_col>.trade_card.overflow_card {\n        order: 1;\n        width: 100%;\n    }\n\n    .otc_tradingpage .midgraph_col>.trade_card.trade_chart {\n        order: 2;\n        width: 100%;\n    }\n\n    .otc_tradingpage .col-12.mmn_btm_minus_spc {\n        order: 3;\n        width: 100%;\n        padding-left: 5px;\n        margin-top: 0px;\n    }\n\n    .otc_tradingpage .trade_account_summary_assets {\n        order: 4;\n        width: 100%;\n        margin-top: 5px;\n    }\n\n    .trade_card.p-3.marketsnapshot {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .otc_tradingpage .headline_left__lBBPY_leftmain {\n        flex-wrap: wrap;\n        gap: 8px 12px;\n    }\n\n    .otc_tradingpage .headline_left__lBBPY_rightmain {\n        margin-left: 0 !important;\n        margin-top: 6px;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .otc_tradingpage .midgraph_col .trade_card.trade_chart {\n        height: auto !important;\n        min-height: 0;\n    }\n\n    /* Mobile bottom-sheet pair popup overlay */\n    .mobile-favourites-popup-overlay {\n        display: flex !important;\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 9999999999 !important;\n    }\n\n    .otc_tradingpage .otc_hist_body {\n        display: none;\n    }\n\n    .otc_tradingpage .otc_hist_mobile {\n        display: block;\n        padding: 0 12px 16px;\n    }\n\n    .otc_tradingpage .trade_account_summary_assets .order_history_mobile_view {\n        padding-bottom: 20px;\n    }\n\n    .otc_tradingpage {\n        padding-bottom: 75px !important;\n    }\n\n    .otc_tradingpage .order_history_mobile_view .orders-mobCard {\n        padding-bottom: 14px;\n        border-bottom: 1px solid #2b313c;\n        margin-bottom: 14px;\n    }\n\n    body.light_theme .otc_tradingpage .order_history_mobile_view .orders-mobCard {\n        border-bottom-color: #e5e7eb;\n    }\n\n    .otc_tradingpage .bs_tab_row {\n        position: fixed;\n        bottom: 0;\n        z-index: 9999;\n        width: 100%;\n        left: 0;\n        padding: 12px 16px;\n        background: #16171b;\n        border-top: 1px solid #2b313c;\n    }\n\n    body.light_theme .otc_tradingpage .bs_tab_row {\n        background: #ffffff;\n        border-color: #e5e7eb;\n    }\n\n    .otc_tradingpage .bs_tab_row .btn {\n        font-weight: 600;\n        font-size: 15px;\n        padding: 10px;\n        border-radius: 6px;\n    }\n\n    .otc_tradingpage .bs_tab_row .btn-success {\n        background-color: #2BC287 !important;\n        border-color: #2BC287 !important;\n        color: #fff !important;\n    }\n\n    .otc_tradingpage .bs_tab_row .btn-danger {\n        background-color: #F74B60 !important;\n        border-color: #F74B60 !important;\n        color: #fff !important;\n    }\n\n    /* Modal bottom-sheet popup drawer for mobile OTC Buy/Sell */\n    .otc_tradingpage .bs_dropbox:not(.d-none) {\n        position: fixed !important;\n        top: 0 !important;\n        left: 0 !important;\n        right: 0 !important;\n        bottom: 0 !important;\n        width: 100% !important;\n        background-color: rgba(0, 0, 0, 0.65) !important;\n        backdrop-filter: blur(4px) !important;\n        -webkit-backdrop-filter: blur(4px) !important;\n        z-index: 999999999 !important;\n        display: flex !important;\n        align-items: flex-end !important;\n        justify-content: center !important;\n    }\n\n    body.light_theme .otc_tradingpage .bs_dropbox:not(.d-none) {\n        background-color: rgb(255 255 255 / 65%) !important;\n    }\n\n    .otc_tradingpage .bs_dropbox:not(.d-none) .buysell_card {\n        width: 100% !important;\n        max-height: 85vh !important;\n        min-height: auto !important;\n        overflow-y: auto !important;\n        border-radius: 16px 16px 0 0 !important;\n        border-bottom: none !important;\n        background-color: #121316 !important;\n        box-shadow: 0 -5px 25px rgba(0, 0, 0, 0.5) !important;\n        animation: slideUp 0.3s ease !important;\n        padding: 16px !important;\n    }\n\n    body.light_theme .otc_tradingpage .bs_dropbox:not(.d-none) .buysell_card {\n        background-color: #ffffff !important;\n        box-shadow: 0 -5px 25px rgba(0, 0, 0, 0.15) !important;\n    }\n\n    @keyframes slideUp {\n        from {\n            transform: translateY(100%);\n            opacity: 0;\n        }\n\n        to {\n            transform: translateY(0);\n            opacity: 1;\n        }\n    }\n\n}\n\n@media screen and (min-width: 992px) {\n    .otc_tradingpage .bs_dropbox {\n        display: block !important;\n        position: static !important;\n        width: 100% !important;\n        background: transparent !important;\n        backdrop-filter: none !important;\n        -webkit-backdrop-filter: none !important;\n        z-index: auto !important;\n    }\n\n\n}\n\n/* Coin Icons Styling */\n.otc_tradingpage .round_img,\n.round_img {\n    border-radius: 50% !important;\n    object-fit: cover !important;\n    vertical-align: middle !important;\n}\n\n.otc_tradingpage .spot_orders_table td img.round_img {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n}\n\n.otc_tradingpage .headline_bigName__dspVW img.round_img {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n}\n\n.otc_tradingpage .marketsnapshot img.round_img {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n}\n\n.otc-amount-error,\n.otc-amount-warning {\n    margin: 6px 0 0;\n    font-size: 12px;\n    line-height: 1.4;\n}\n\n.otc-amount-error {\n    color: #f07178;\n}\n\nbody.light_theme .trade_favourites_lft.is-open {\n    background-color: #fdfdfd;\n}\n\n/* Chart pair menu on OTC only: height follows the pair rows. */\n/* .otc_tradingpage .trade_favourites_lft.is-open {\n    height: auto;\n    max-height: calc(100vh - 120px);\n} */\n\n/* .otc_tradingpage .trade_favourites_lft.is-open .spotLists,\n.otc_tradingpage .trade_favourites_lft .spotLists {\n    height: auto;\n    max-height: calc(100vh - 120px);\n} */\n\n.otc_tradingpage .trade_favourites_lft.is-open .price_card,\n.otc_tradingpage .trade_favourites_lft.is-open .price_card.table-responsive,\n.otc_tradingpage .trade_favourites_lft .table-responsive {\n    flex: none;\n    height: auto;\n    min-height: 0;\n    max-height: calc(100vh - 220px);\n    overflow: auto;\n}\n\n.otc-amount-warning {\n    color: #e6b450;\n}\n\nbody.light_theme .otc-amount-warning {\n    color: #9a6b00;\n}\n\n.buysellform .input-group .form-control.otc-amount-input {\n    flex: 1 1 auto;\n    min-width: 0;\n    cursor: text;\n}\n\n.buysellform .input-group .form-control.otc-amount-input::placeholder {\n    color: rgba(255, 255, 255, 0.35) !important;\n    font-weight: 400;\n    opacity: 1;\n}\n\n.buysellform .input-group .form-control.otc-amount-input:focus::placeholder {\n    color: transparent !important;\n}\n\nbody.light_theme .buysellform .input-group .form-control.otc-amount-input::placeholder {\n    color: #94a3b8 !important;\n}\n\n@media screen and (max-width:767px) {\n\n    .otc-header-pair__symbol {\n        font-size: 13px;\n    }\n\n    .otc_tradingpage .round_img,\n    .round_img {\n        width: 24px !important;\n        height: 24px !important;\n        min-width: 24px;\n    }\n\n    .trade_card.trade_chart.buysell_card.buysell_two ul.favorites_list_tabs li button {\n        font-size: 12px;\n    }\n\n    .otc_tradingpage .otc-header-pair .trade_favourites_lft {\n        width: min(440px, 84vw) !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
